import axios from 'axios';
import config from './config.js';

const BASE_URL = config.apiProtocol + '://' + config.apiUrl + '/';
const HEADERS = {
    'Content-Type': 'application/json; charset=utf-8'
};

console.log('API URL:', BASE_URL);

function getBaseUrl() {
    return (window.apiProtocol || 'https') + '://' + (window.apiUrl || 'solo.minemine.online/api') + '/';
}

let token = null;

function callCommonEndpointWithTotal(endpoint, method, data) {
    console.log(BASE_URL + endpoint);
    if (!method) method = 'get';
    return axios({
        method,
        url: BASE_URL + endpoint,
        headers: HEADERS,
        data: JSON.stringify(data),
        params: method == 'get' ? data : undefined
    }).then((response) => {
        return {
            data: response.data,
            total: (response.data._meta || {}).total || 0
        }
    });
}

function get(endpoint, query) {
    return axios({
        method: 'get',
        url: getBaseUrl() + endpoint,
        headers: HEADERS,
        params: query
        // data: JSON.stringify(data)
    }).then((response) => {
        return response.data
    });
}

function post(endpoint, data) {
    return axios({
        method: 'post',
        url: getBaseUrl() + endpoint,
        headers: HEADERS,
        data: JSON.stringify(data)
    }).then((response) => {
        return response.data
    });
}

export default {
    setToken(t) {
        token = t;
        HEADERS.Authorization = 'Bearer ' + token;
    },

    mine: {
        blocks: (coin) => get(`mine/${coin}/blocks`),
        stats: (coin) => get(`mine/${coin}/stats`),
        submitsChart: (coin) => get(`mine/${coin}/chart_data/submits`),
        generatedWork: (coin, min = 5) => get(`mine/${coin}/work_generated/${min}`),
        generatedWorkSinceLastBlock: (coin) => get(`mine/${coin}/work_generated_since_last_block`),
        chart: {
            difficulty: (coin) => get(`mine/${coin}/chart_data/diff`)
        }
    },

    miner: {
        jobs: (coin, wallet) => get(`miner/${coin}/${wallet}/last_jobs`),
        submits: (coin, wallet) => get(`miner/${coin}/${wallet}/last_submits`),
        blocks: (coin, wallet) => get(`miner/${coin}/${wallet}/blocks`),
        generatedWork: (coin, wallet, min = 5) => get(`miner/${coin}/${wallet}/work_generated/${min}`),
        submitsChart: (coin, wallet) => get(`miner/${coin}/${wallet}/chart_data/submits`)
    },


    // to jest tak na prawde hashbuy service - ale nie zmieniamy nazwy ze wzgledu na kompatybilnosc
    pool: {
        nextPayoutDate: () => get(`pool/nextPayoutDate`),
        currentPrices: () => get(`pool/currentPrices`),
        miner: {
            generatedWork: (coin, wallet, min = 5) => get(`pool/${coin}/${wallet}/work_generated/${min}`),
            balance: (coin, wallet) => get(`pool/${coin}/${wallet}/balance`),
            payouts: (coin, wallet) => get(`pool/${coin}/${wallet}/payouts`),
            paid: (coin, wallet) => get(`pool/${coin}/${wallet}/paid_last_month`),
            submitsChart: (coin, wallet) => get(`pool/${coin}/${wallet}/chart_data/submits`)
        }
    },

    ppool: {
        get: (poolId) => get(`ppool/${poolId}`),
        submitsChart: (poolId) => get(`ppool/${poolId}/chart_data/submits`),
        generatedWork: (poolId, min = 5) => get(`ppool/${poolId}/work_generated/${min}`),
    },

    ticket: {
        get: (ticketCode) => get(`ticket/${ticketCode}`),
        getTicketPrices: () => get(`ticket/prices`),
    },

    stats: {
        network: (coin) => get(`stats/network/${coin}`),
        diffHistory: (coin) => get(`stats/network/${coin}/diff_history`),
    },

    party: {
        get: (partyCode) => get(`party/${partyCode}`),
        join: (partyId, wallet, ticketCode, uses = 1) => post(`party/${partyId}/join`, { wallet, ticketCode, uses }),
        generatedWork: (partyId, min = 5) => get(`party/${partyId}/work_generated/${min}`),
        submitsChart: (partyId) => get(`party/${partyId}/chart_data/submits`)
    },

    hardware: {
        get: (urlSlug) => get(`hardware/${urlSlug}`),
        list: () => get(`hardware`),
        generateSoloPoolsForAlgo: (algo, hardwareHashrate) => post(`hardware/generateSoloPoolsForAlgo`, { algo, hardwareHashrate })
    },
};
